import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, throwError } from "rxjs";
import { ToastService } from "../../utils/toast.service";


export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);

  return next(req).pipe(
      catchError((error:HttpErrorResponse)=>{
          if(error.status === 400){
              toastService.showToast(
                  'fi fi-ss-diamond-exclamation text-[24px] text-[#FF3030]', 
                  'Solicitud inválida. Verifica los datos enviados.', 
                  'error'
              );
      
          }else if(error.status === 500){
              toastService.showToast(
                  'fi fi-ss-diamond-exclamation text-[24px] text-[#FF3030]', 
                  'Error interno del servidor. Intenta nuevamente más tarde.', 
                  'error'
              );
          }
          return throwError(()=>error.error.message);
      })
  )
};